function toCnMoney(num) {
    var result = "";
    var units = "仟佰拾亿仟佰拾万仟佰拾元角分";
    var strValue = String(num);
    strValue += "00";
    var dotIndex = strValue.indexOf(".");
    if (dotIndex >= 0) {
        strValue = strValue.substring(0, dotIndex) + strValue.substr(dotIndex + 1, 2);
    }
    units = units.substr(units.length - strValue.length);
    for (var i = 0; i < strValue.length; i++) {
        result += "零壹贰叁肆伍陆柒捌玖".substr(strValue.substr(i, 1), 1) + units.substr(i, 1);
    }
    return result
        .replace(/零角零分$/, "整")
        .replace(/零[仟佰拾]/g, "零")
        .replace(/零{2,}/g, "零")
        .replace(/零([亿|万])/g, "$1")
        .replace(/零+元/, "元")
        .replace(/亿零{0,3}万/, "亿")
        .replace(/^元/, "零元");
}

function moneyToShort(num) {
    return toCnMoney(num);
}

export default {
    toCnMoney,
    moneyToShort
};

export {
    toCnMoney,
    moneyToShort
};
